(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefit-collection-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.benefit-section');
    const list = section?.querySelector('.benefit-section_wrap');
    if (!section || !list) return;

    const triggerPoint = section.offsetTop;
    let lastScroll = window.scrollY;

    const getHeaderHeight = () => {
      return parseInt(
        getComputedStyle(document.documentElement)
          .getPropertyValue('--header-height')
      ) || 0;
    };

    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      const headerHeight = getHeaderHeight();

      if (currentScroll > triggerPoint) {
        list.classList.add('is-sticky');

        if (currentScroll > lastScroll) {
          // scrolling down → stick at very top
          list.style.top = '0px';
        } else {
          // scrolling up → below header
          list.style.top = `${headerHeight}px`;
        }

      } else {
        list.classList.remove('is-sticky');
        list.style.top = '';
      }

      lastScroll = currentScroll;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmn-supplements-boost-energy-aging"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
      window.scrollTo(0, 0);
  });

  window.onscroll = function () {
    updateProgressBar();
    toggleProgressBarPosition();
  };

  function updateProgressBar() {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;

    // Define que o progresso mínimo é 5% e o restante continua a partir disso
    var progressWidth = 5 + scrolled * 0.95; // 5% inicial e os 95% restantes são o scrolled
    // Limita o progresso máximo em 100%
    if (progressWidth > 100) {
      progressWidth = 100;
    }

    document.getElementById('progress-bar').style.width = progressWidth + '%';
  }

  function toggleAsideClassOnScroll() {
    // Altura total da página
    const totalHeight = document.documentElement.scrollHeight;

    // 15% e 90% da altura total
    const triggerHeight = totalHeight * 0.01;
    const finalTriggerHeight = totalHeight * 0.9;

    // Elemento alvo
    const asideContainer = document.querySelector('.aside-container');

    // Adiciona ou remove a classe baseado na posição do scroll
    if (window.scrollY > triggerHeight && window.scrollY <= finalTriggerHeight) {
      asideContainer.classList.add('aside-container-active');
      asideContainer.style.top = ''; // Remove o ajuste de `top` quando dentro dessa faixa
    } else if (window.scrollY > finalTriggerHeight) {
      asideContainer.style.top = '-30px'; // Define a posição `top` quando passar de 90% da altura
    } else {
      asideContainer.classList.remove('aside-container-active');
      asideContainer.style.top = ''; // Reseta o `top` quando não estiver nas condições
    }
  }

  // Adiciona o evento de rolagem para monitorar o scroll
  window.addEventListener('scroll', toggleAsideClassOnScroll);

  function toggleFooterClassOnScroll() {
    // Altura total da página
    const totalHeight = document.documentElement.scrollHeight;

    // 40% da altura total
    const triggerHeight = totalHeight * 0.4;

    // Elemento alvo (footer)
    const footer = document.querySelector('footer');

    // Adiciona ou remove a classe baseado na posição do scroll
    if (window.scrollY > triggerHeight) {
      footer.classList.add('footer-active');
    } else {
      footer.classList.remove('footer-active');
    }
  }

  // Adiciona o evento de rolagem para monitorar o scroll
  window.addEventListener('scroll', toggleFooterClassOnScroll);

  function toggleProgressBarPosition() {
    var progressBar = document.getElementById('progress-bar');
    var viewportHeight = window.innerHeight;

    // Verifica se o scroll passou de 10% do height do viewport
    if (window.scrollY > viewportHeight * 0.1) {
      progressBar.style.position = 'fixed';
      progressBar.style.top = '0';
    } else {
      progressBar.style.position = 'relative';
    }
  }

  // Vertical Progress Pag

  window.addEventListener('scroll', function () {
    updateVerticalProgressBar();
  });

  function updateVerticalProgressBar() {
    const sections = [
      { id: 'the-man', li: document.querySelector('a[href="#the-man"]').parentElement },
      { id: 'the-book', li: document.querySelector('a[href="#the-book"]').parentElement },
      { id: 'nmn', li: document.querySelector('a[href="#nmn"]').parentElement },
      { id: 'is-the-new', li: document.querySelector('a[href="#is-the-new"]').parentElement },
      { id: 'i-feel-young-again', li: document.querySelector('a[href="#i-feel-young-again"]').parentElement },
    ];

    const windowHeight = window.innerHeight;
    let totalHeight = document.documentElement.scrollHeight - windowHeight;
    let scrolled = window.scrollY;

    // Pega a altura inicial da primeira seção
    const firstSection = document.getElementById('the-man');
    const firstSectionHeight = firstSection.getBoundingClientRect().height;

    // Calcular o progresso da barra de rolagem considerando a primeira seção já "ativa"
    let progressPercentage = ((scrolled + firstSectionHeight) / totalHeight) * 100;

    // Atualizar a altura do progress-bar vertical, garantindo que comece com a altura da primeira seção
    document.getElementById('progress-bar-vertical').style.height = progressPercentage + '%';

    // Verificar se a seção está visível ou passou no scroll
    sections.forEach((section, index) => {
      const sectionElement = document.getElementById(section.id);
      const sectionTop = sectionElement.getBoundingClientRect().top;

      // Se a seção estiver acima da metade da tela, considere-a "passada"
      if (sectionTop < window.innerHeight / 2) {
        // Adiciona a classe "section--active" para a seção atual e todas as anteriores
        for (let i = 0; i <= index; i++) {
          sections[i].li.classList.add('section--active');
        }
      } else {
        // Remove a classe "section--active" para as seções subsequentes que ainda não foram passadas
        section.li.classList.remove('section--active');
      }
    });
  }

  document.querySelector('.sticky--progress').addEventListener('click', function () {
    this.classList.toggle('tw-h-fit');
  });

  } catch(e) { console.error(e); }
})();
})();
